import React from 'react'
import AccountPresentation from '../../../components/Admin/Account'
import { AdminContainer } from '../'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { Segment } from 'semantic-ui-react'

export default function Account() {
  return (
    <React.Fragment>
      <PageHeaderContainer title="Workspace settings" />
      <AdminContainer>
        <Segment className="admin-section">
          <AccountPresentation />
        </Segment>
      </AdminContainer>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Account/index.js